import { getRequest, postRequest } from '../../../api/api';

export function getWithdrawModalOptions(values, callbackResponse) {
    return getRequest(
        'api/v1/wallet/fetch-withdraw-options',
        values,
        callbackResponse
    );
};

export function postSubmitWithdrawal(values, callbackResponse, callbackError) {
    return postRequest(
        'api/v1/wallet/withdraw',
        null,
        values,
        callbackResponse,
        callbackError
    );
};

export function getInvestModalOptions(callbackResponse) {
    return getRequest(
        'api/v1/wallet/fetch-invest-options',
        null,
        callbackResponse
    );
};

export function postSubmitInvest(values, callbackResponse, callbackError) {
    return postRequest(
        'api/v1/investment/invest',
        null,
        values,
        callbackResponse,
        callbackError
    );
};